export default __webpack_public_path__ + "static/media/angle.37c3fcb4.svg";